import * as React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from '@siteground/styleguide';

import { closeSGDialog } from '../../actions/sg-dialog';

const CancelButton = ({ closeSGDialog, e2eAttr = 'dialog-close', id, intl, label }) => (
  <Button color="primary" type="ghost" action="button" data-e2e={e2eAttr} onClick={() => closeSGDialog(id)}>
    {label || intl.formatMessage({ id: 'translate.generic.cancel' })}
  </Button>
);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  closeSGDialog: (id) => dispatch(closeSGDialog(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CancelButton));
